import { FC } from 'react'
import { DayContainer, MealsContainer } from './styled'
import { Meal } from './meal'
import { MAIN_COLOR_QRM } from 'shared/globalConsts'

export const Day: FC<DayProps> = ({ dayName, dayValue }) => {
  return (
    <DayContainer>
      <h3 style={{ color: `${dayValue > 4 ? MAIN_COLOR_QRM : 'unset'}` }}>{dayName}</h3>
      <MealsContainer>
        <Meal mealType='lunch' dayValue={dayValue} />
        <Meal mealType='dinner' dayValue={dayValue} />
      </MealsContainer>
    </DayContainer>
  )
}

type DayProps = {
  dayName: string
  dayValue: number
}
